import { ReactNode } from "react";

import Close from "assets/close-small.svg";

import { ReactComponent as Agent } from "assets/SidebarIcons/peoplesafeone.svg";

import { PopupTemplateSkeleton } from "./skeleton";
import { Wrapper } from "./styles";

type Props = {
  children?: ReactNode;
  title?: string;
  subtitle?: string;
  containerClassName?: string;
  onPopupClose?: () => void;
  isLoading?: boolean;
  renderButtons?: ReactNode;
  icon?: ReactNode;
};

function PopupTemplate({
  children,
  containerClassName,
  title = "Template",
  subtitle = "Template",
  onPopupClose = () => {},
  isLoading = false,
  renderButtons,
  icon,
}: Props) {
  if (isLoading) {
    return (
      <PopupTemplateSkeleton renderButtons={renderButtons}>
        {children}
      </PopupTemplateSkeleton>
    );
  }

  return (
    <Wrapper>
      <div className={`${"container"} ${containerClassName}`}>
        <div className="header">
          <div className="headerBody">
            {icon && <div className="iconContainer">{icon}</div>}
            <header>
              <p className={`${"title"} ${icon && "withIcon"}`}>{title}</p>

              <span className="coordText">{subtitle}</span>
            </header>
          </div>

          <button
            className="closeButton"
            type="button"
            onClick={() => onPopupClose()}
          >
            <img src={Close} alt="Botão de fechar o pop-up" />
          </button>
        </div>

        <div className="body">
          <div
            className={`${"buttonContainer"} ${!children && "witouthDivider"}`}
          >
            {renderButtons}
          </div>
        </div>

        {children}
      </div>
    </Wrapper>
  );
}

export { PopupTemplate };
